import { t } from 'i18next'
import * as yup from 'yup'

const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(?<!\.)@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/

export const validationSchema = yup.object().shape({
  email: yup
    .string()
    .matches(
      emailRegex,
      () => t('registrationPage.errorMessages.invalidEmail') || 'Please, enter a valid email'
    )
    .max(255)
    .required('Email is required'),
})
